<template>
  <navigation-drawer
    @close="(value) => $emit('close', value)"
    :open="open"
    :logo-url="logoUrl"
    :items="items"
    :has-custom-logo="hasCustomLogo"
  />
</template>

<script>
import { getProviderLogo } from "Adapters/ApiAdapter/user";
import NavigationDrawer from "Components/NavigationDrawer";
import { parseLogoUrl } from "PublicHelpers/Logo/parseLogoUrl";
import userMixin from "Shared/mixins/userMixin";

export default {
  name: "PublicNavigationDrawer",
  components: { NavigationDrawer },
  mixins: [userMixin],
  computed: {
    logoUrl() {
      const { file_url } = this.customLogo ?? {};
      return file_url ?? parseLogoUrl();
    },
    hasCustomLogo() {
      return !!Object.keys(this.customLogo).length;
    },
  },
  props: {
    open: {
      type: Boolean,
      default: true,
    },
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      customLogo: {},
    };
  },

  methods: {
    updateCustomLogo() {
      if (this.user && this.user.id) {
        getProviderLogo().then((response) => {
          if (!response) return;
          this.customLogo = Object.assign({}, response.data);
        });
      }
    },
  },
  created() {
    this.$root.$on("refreshLogo", this.updateCustomLogo);
  },
  mounted() {
    this.updateCustomLogo();
  },
  beforeDestroy() {
    this.$root.$off("refreshLogo", this.updateCustomLogo);
  },
};
</script>

<style lang="scss">
hr.v-divider {
  margin: 0 0 30px 0 !important;
}
</style>
